import { makeStyles } from "@material-ui/core/styles";
import {
  h4Light,
  h4Medium,
  h5Light,
  h5Medium,
  h6Medium,
  h6Regular,
  h7Regular,
} from "../../../shared/typography";
import { pointer, withOpacity } from "../../../shared/mixins";

export const useStyles = makeStyles(() => ({
  card: {
    borderRadius: 16,
    padding: 40,
    background: "#fff",
    maxWidth: 660,
    width: "100%",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    gap: 40,
    "@media (max-width: 940px)": {
      maxWidth: "100%",
      gap: 0,
      padding: 24,
    },
  },

  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 12,
    "@media (max-width: 940px)": {
      flexDirection: "column",
      gap: 16,
      width: "100%",
      alignItems: "start",
      marginBottom: 0,
    },
  },

  deliveryDividerRes: {
    "@media (min-width: 940px)": {
      display: "none",
    },
    "@media (max-width: 940px)": {
      display: "flex",
      width: "100%",
      height: 1,
      borderBottom: "1px dashed rgba(21, 34, 47, 0.18)",
    },
  },

  deliveryTimelineRes: {
    "@media (max-width: 940px)": {
      display: "flex",
      width: "100%",
      justifyContent: "center",
      paddingBottom: 16,
      borderBottom: "1px dashed rgba(21, 34, 47, 0.18)",
    },
  },

  deliveryIndex: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    "@media (max-width: 940px)": {
      gap: 8,
    },
  },

  deliveryIndexHeader: {
    ...h4Light,
    ...withOpacity(0.8),
    "@media (max-width: 940px)": {
      ...h5Light,
    },
  },
  deliveryIndexDate: {
    ...h4Medium,
    ...withOpacity(0.8),
    "@media (max-width: 940px)": {
      ...h5Medium,
    },
  },
  itemsList: {
    display: "flex",
    flexDirection: "column",
  },
  itemsListTotal: {
    ...h6Regular,
    ...withOpacity(0.4),
    marginBottom: 24,
    "@media (max-width: 940px)": {
      display: "none",
      marginBottom: 0,
    },
  },
  itemRow: {
    display: "grid",
    gridTemplateColumns: "6fr 3fr 1fr",
    alignItems: "center",
    padding: "24px 0",
    borderBottom: "1px dashed rgba(21, 34, 47, 0.18)",

    "&:last-child": {
      borderBottom: "none",
    },

    "@media (max-width: 940px)": {
      gridTemplateColumns: "1fr auto",
      width: "100%",
      padding: "16px 0",
    },
  },
  leftDesktop: {
    display: "flex",
    alignItems: "center",
    gap: 24,
    "@media (max-width: 940px)": {
      display: "none",
    },
  },
  leftRes: {
    display: "none",
    "@media (max-width: 940px)": {
      display: "flex",
      gap: 16,
      width: "100%",
    },
  },
  leftResTextContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    "@media (max-width: 940px)": {
      width: "100%",
    },
  },
  leftResTotalContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  leftResQuantity: {
    ...h7Regular,
    ...withOpacity(0.64),
  },
  leftResTotal: {
    ...h6Medium,
    ...withOpacity(0.72),
  },
  image: {
    width: 56,
    height: 56,
    objectFit: "cover",
    borderRadius: 6,
  },
  name: {
    ...h6Regular,
    ...withOpacity(0.64),
    whiteSpace: "nowrap",
  },
  center: {
    display: "flex",
    alignItems: "center",
    gap: 16,
    "@media (max-width: 940px)": {
      display: "none",
    },
  },
  heartIcon: {
    height: 40,
    width: 40,
  },
  basketIcon: {
    height: 40,
    width: 40,
    background: "#80BB34",
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ...pointer,
  },
  qtyLabel: {
    ...h7Regular,
    ...withOpacity(0.4),
  },
  qty: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  qtyValue: {
    fontFamily: "Barlow",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "20px",
    lineHeight: "24px",
    color: "#15222F",
    ...withOpacity(0.64),
  },
  right: {
    justifySelf: "end",
    ...h6Medium,
    ...withOpacity(0.72),
    "@media (max-width: 940px)": {
      display: "none",
    },
  },
  unavailableItemsCenter: {
    justifySelf: "center",
    "@media (max-width: 940px)": {
      display: "none",
    },
  },
}));
